module.exports = __webpack_public_path__ + "static/Hotel-3ea836faad724dee831769f1fafda9ab.png";